/**
 *
 * Used to localized message string coming from the server to human-readable text
 * load text from i18n files in required language
 */
import { domainStore } from '@/store/domain-store';
export default function () {
  const messagesHash: Map<string, string> = new Map([
    ['email is invalid', 'email-is-invalid'],
    ['email exists', 'email-exists'],
    ['gmail is taken', 'gmail-is-taken'],
    ['email is throwaway', 'email-is-throwaway'],
    ['password is too short or not secure enough', 'password-invalid'],
    ['displayname is taken', 'displayname-taken'],

    ['no content found', 'no-content-found'],
    ['cannot create thought for this topic', 'cannot-create-thought'],
    ['user cannot edit this thought', 'cannot-edit-thought'],
    ['Vielen Dank für Ihre Eingabe.', 'thought-created'],
    [
      'Vielen Dank für Ihre Eingabe. Diese wird nun von der Moderation geprüft. Wenn Ihre Eingabe im System freigegeben wird, erhalten Sie eine E-Mail.',
      'thought-created-moderated',
    ],
    ['thought is successfully edited', ''],

    ['voting is disabled', 'voting-disabled'],
    ['voting needs login', 'voting-requires-login'],
    ['cannot vote your own thought', 'cannot-vote-own-thought'],
    ['attach_link_url too long', 'url-too-long'],
    ['attachment is bigger than allowed size', 'attachment-too-big'],

    ['Bitte geben Sie eine Antwort auf die Sicherheitsabfrage ein.', 'captcha-empty'],
    [
      'Die Antwort auf die Sicherheitsabfrage war nicht korrekt. Bitte versuchen Sie es noch einmal.',
      'captcha-invalid',
    ],
  ]);

  /**
   * returns a localized error message from the given server string, or the string itself if the localized message is not found
   * if the localized string has parameters you can also pass array of string to replace them, based on the index
   * make sure you write params in i18n files like {value0} {value1}, etc.
   * @param key error message from server
   * @param params extra string parameters for localized message
   * @returns the localized error message or the original string if not found
   */
  function l(key: string, params: Array<string> = []): string {
    console.log('useLocalizeMessage', key, params);
    const value = messagesHash.get(key);
    if (value) {
      const paramsObj: any = {};
      params.forEach((p, idx) => {
        paramsObj['value' + idx] = p;
      });
      return domainStore.translate('general.message.from-server.' + value, paramsObj);
    }
    return key;
  }

  return { l };
}
